import { ContractsApi } from '@seek/sbiz-shared-types';
import {
  Box,
  Divider,
  Heading,
  Hidden,
  List,
  Page,
  PageBlock,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
import { useSearchParams } from 'react-router-dom';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { useEffectOnce } from 'src/hooks/useEffectOnce';
import { tracking } from 'src/tracking';

const isValidProductType = (value: string | null): value is string =>
  value === ContractsApi.StandardContractType ||
  value === ContractsApi.AccelerateContractType;

export const UpgradeContractRequestConfirmation = () => {
  const [searchParams] = useSearchParams();

  const productType = searchParams.get('productType');
  const listingId = searchParams.get('listingId') ?? '';
  const clientId = searchParams.get('clientId') ?? '';
  const contractStartDate = searchParams.get('contractStartDate') ?? '';

  useEffectOnce(() => {
    if (isValidProductType(productType)) {
      tracking.sellerDashboard.upgradeContractRequest.confirmation.viewed({
        tier: productType,
        listingId,
        sbizClientId: clientId,
        contractStartDate,
      });
    }
  });

  return (
    <Page footer={<SiteWideFooter />} footerPosition="belowFold">
      <Header title="Sell your business" />

      <Hidden below="tablet">
        <Divider />
      </Hidden>

      <Box paddingTop="xlarge">
        <PageBlock width="small">
          <Stack space="xlarge">
            <Stack space="medium">
              <Heading level="2" component="h1">
                More buyer exposure is coming your way
              </Heading>

              <Text>
                Thanks for choosing to upgrade your listing. At the moment, we
                do this manually, so it may take 1-2 business days for your
                listing type to change.
              </Text>
            </Stack>

            <Stack space="medium">
              <Heading level="3">Here&apos;s what to expect next</Heading>

              <List space="small">
                <Text>We will call you to confirm your choice</Text>
                <Text>You will receive a secure payment link via email</Text>
                <Text>We will upgrade your listing</Text>
              </List>
            </Stack>

            <Text>
              If you have any questions in the meantime, feel free to get in
              touch on{' '}
              <TextLink href="tel:137335" hitArea="large">
                13 73 35
              </TextLink>{' '}
              or{' '}
              <TextLink
                href="mailto:enquiries@seekbusiness.com.au"
                hitArea="large"
              >
                enquiries@seekbusiness.com.au
              </TextLink>
              .
            </Text>
          </Stack>
        </PageBlock>
      </Box>
    </Page>
  );
};
